import type { TFunction } from 'i18next';

export const getLocalizedTariffName = (id: number, fallback: string, t: TFunction) =>
	t(`tariff-modal.names.${id}`, { defaultValue: fallback });
